import React from "react";

// Material UI
import { Stack, Typography, Button } from "@mui/material";
import { ClearRounded, Visibility, VisibilityOff } from "@mui/icons-material";

// Styles
import { styles as textStyles } from "Common/Styles/TextStyles";
import { styles as buttonStyles } from "Common/Styles/ButtonStyles";

const AdminSettingDeleteHeader = ({
  name,
  index,
  onDeleteClick,
  isVisible,
  onVisibleClick,
  viewOnly = false,
}) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography sx={textStyles.subtitle}>
        {name} {index + 1}
      </Typography>
      <Stack direction="row" alignItems="center" gap={1}>
        {onVisibleClick && (
          <Button
            variant="outlined"
            color="primary"
            sx={
              isVisible
                ? buttonStyles.outlineGreenActionButton
                : buttonStyles.outlineGreyActionButton
            }
            onClick={viewOnly ? undefined : onVisibleClick}
          >
            {isVisible ? <Visibility /> : <VisibilityOff />}
            <Typography variant="button">
              {isVisible ? "Visible" : "Hidden"}
            </Typography>
          </Button>
        )}
        {!viewOnly && onDeleteClick && (
          <Button variant="outlined" color="error" onClick={onDeleteClick}>
            <ClearRounded />
            <Typography variant="button">Delete {name}</Typography>
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default AdminSettingDeleteHeader;
